export default function generateGoogleMapsUrl() {
  const $block = $('.js-generateGoogleMapsUrl');

  $block.each((i, block) => {
    const $startArea = $(block).find('.js-startArea');
    const $startAreaLink = $startArea.find('li a');
    const $otherStartText = $(block).find('.js-otherStartArea');
    const $endArea = $(block).find('.js-endArea');
    const $endAreaLink = $endArea.find('li a');
    const $otherEndText = $(block).find('.js-otherEndArea');
    const $link = $(block).find('.js-googleMapsUrl');
    $startAreaLink.on({
      click(e) {
        e.preventDefault();
        const $this = $(this);
        const hash = $this.attr('href');
        const saddr = hash.replace('#', '');
        $startAreaLink.removeClass('_current');
        $this.addClass('_current');
        $link[0].dataset.saddr = saddr;
        if ($otherStartText.val()) {
          $otherStartText.val('');
        }
      },
    });
    $otherStartText.on({
      input() {
        const value = $(this).val();
        $startAreaLink.removeClass('_current');
        $link[0].dataset.saddr = value;
      },
    });
    $endAreaLink.on({
      click(e) {
        e.preventDefault();
        const $this = $(this);
        const hash = $this.attr('href');
        const daddr = hash.replace('#', '');
        $endAreaLink.removeClass('_current');
        $this.addClass('_current');
        $link[0].dataset.daddr = daddr;
        if ($otherStartText.val()) {
          $otherStartText.val('');
        }
      },
    });
    $otherEndText.on({
      input() {
        const value = $(this).val();
        $startAreaLink.removeClass('_current');
        $link[0].dataset.daddr = value;
      },
    });
    $link.on({
      click(e) {
        e.preventDefault();
        const $this = $(this);
        const href = $this.attr('href');
        const { saddr, daddr } = $this[0].dataset;
        const url = `${href}?saddr=${saddr}&daddr=${daddr}`;
        window.open(url, '_blank');
      },
    });
  });
}
